const PricingStore = {
    state: {
        versions: [],
        revisions: [],
        plans: [],
        products: [],
        current: {
            version: null,
            revision: null,
            plan: null
        }
    },
    mutations: {
        // List
        setPricingVersions(state, data) { state.versions = data },
        setPricingRevisions(state, data) { state.revisions = data },
        setPricingPlans(state, data) { state.plans = data },
        setPricingProducts(state, data) { state.products = data },
        // Prop
        setCurrentPricingVersion(state, data) { state.current.version = data },
        setCurrentPricingRevision(state, data) { state.current.revision = data },
        setCurrentPricingPlan(state, data) { state.current.plan = data },
    },
    actions: {
        // List
        defineCurrentPricingVersions({ commit }, value) { commit("setPricingVersions", value) },
        defineCurrentPricingRevisions({ commit }, value) { commit("setPricingRevisions", value) },
        defineCurrentPricingPlans({ commit }, value) { commit("setPricingPlans", value) },
        defineCurrentPricingProducts({ commit }, value) { commit("setPricingProducts", value) },
        // Prop
        defineCurrentPricingVersion({ commit }, value) { commit("setCurrentPricingVersion", value) },
        defineCurrentPricingRevision({ commit }, value) { commit("setCurrentPricingRevision", value) },
        defineCurrentPricingPlan({ commit }, value) { commit("setCurrentPricingPlan", value) },
    },
    getters: {
        pricingVersions: state => state.versions,
        pricingRevisions: state => state.revisions,
        pricingPlans: state => state.plans,
        pricingProducts: state => state.products,
        pricingCurrentVersion: state => state.current.version,
        pricingCurrentRevision: state => state.current.revision,
        pricingCurrentPlan: state => state.current.plan,
    }
}

export default PricingStore;